<template>
  <div>
    <!-- start pemisah  -->
    <div style="width: 100%; background: #ffffff; border-radius: 70px">
      <div class="row" style="margin: 0px; height: 50%">
        <div class="col-lg-12 login-form login-signin" style="padding: 50px">
          <div>
            <h3
              class="mb-5 text-black"
              style="font-weight: 500; font-size: 20px; line-height: 25px"
            >
              Selamat Datang Di
            </h3>
            <h3
              class="mb-5 text-black"
              style="font-weight: 700; font-size: 35px; line-height: 44px"
            >
              Sistem Informasi Akademik
            </h3>
          </div>

          <b-form class="form" @submit.stop.prevent="onSubmit">
            <!-- <div role="alert" v-bind:class="{ show: errors.length }" class="alert fade alert-danger">
            <div class="alert-text" v-for="(error, i) in errors" :key="i">
              {{ error }}
            </div>
          </div> -->

            <b-form-group id="example-input-group-1" label-for="example-input-1">
              <span style="font-weight: 300; font-size: 15px; line-height: 19px"
                >Email</span
              >
              <b-form-input
                class="form-control form-control-solid h-auto"
                id="example-input-1"
                name="example-input-1"
                v-model="$v.form.email.$model"
                :state="validateState('email')"
                aria-describedby="input-1-live-feedback"
                style="
                  height: 50px;
                  background: #ffffff;
                  border: 1px solid #d3d3d3;
                  border-radius: 10px;
                "
                autocomplete="off"
              ></b-form-input>
              <b-form-invalid-feedback id="input-1-live-feedback">
                Email is required and a valid email address.
              </b-form-invalid-feedback>
            </b-form-group>
            <div
              class="form-group d-flex flex-wrap justify-content-between align-items-center"
            >
              <button
                ref="kt_login_signin_submit"
                class="btn font-weight-bold my-3 font-size-3 btn-login"
                style="
                  flex: 1 0 auto;
                  background-color: #00082c;
                  color: white;
                  border-radius: 10px;
                  height: 41px;
                "
              >
                Daftar
              </button>
            </div>
            <div class="form-group d-flex flex-wrap justify-content-center">
              <span class="font-weight-bold font-size-3 text-dark-60">
                Sudah Punya Akun?
              </span>
              <router-link
                class="text-hover-primary font-weight-bold font-size-3 ml-2"
                :to="{ name: 'login' }"
                style="color: black"
              >
                Login!
              </router-link>
            </div>
          </b-form>

          <!-- <div>
          <button @click="showAlert">Test Sweetalert</button>
        </div> -->
          <div class="d-none flex-column-auto d-lg-flex justify-content-center mt-15">
            <div class="d-flex">
              <!-- <a href="#" style="color: black">FAQ |&nbsp;</a>
            <a href="#" style="color: black">Features |&nbsp;</a>
            <a href="#" style="color: black">Support</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- finish pemisah  -->    
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from "vuex";
import axios from "axios";

import { validationMixin } from "vuelidate";
import { email, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "register",
  data() {
    return {
      // Remove this dummy login info
      form: {
        email: "",
      }
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;

      const formData = new FormData();
      formData.append("email", email);
      // await axios({
      //   method: "POST",
      //   url: `${process.env.VUE_APP_BASE_URL}api/login/`,
      //   data: formData,
      //   headers: this.config.headers,
      // }).then(result => {
      //   if (result.data.meta.code == 200) {
      //     localStorage.setItem('dataLogin', JSON.stringify(result.data.data));
      //     this.$router.push({ path: '/dashboard' });
      //   }
      // });
      axios.post("api/register/", formData).then((result) => {
        if (result.data.meta.code == 200) {
          this.$swal('Link Verifikasi Telah dikirim ke E-mail Anda')
          this.$router.push({ path: "/login" });
        }
      });
    },
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
